import { defineComponent as _defineComponent } from 'vue'
import { computed, ref, watch } from "vue";


type Item = {[key: string]: boolean};


export default /*#__PURE__*/_defineComponent({
  __name: 'x-axis',
  props: {
    selectedColumns: {}
  },
  emits: ['update:selectedColumns'],
  setup(__props: any, { expose: __expose, emit }) {
  __expose();

const props = __props;






const handleClick = (item:Item) => {
	// console.log( " HANDLE CLICK IN X AXIS FILE, item: ", item.column, item.k, item.value, item.label)
	emit('update:selectedColumns', item)
}


const __returned__ = { emit, props, handleClick, computed, ref, watch }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})